import React, { Component, Fragment } from 'react';

import LoadMoreButton from '../../../screens/Places/LoadMoreButton';
import Sorter from '../../../screens/Places/Sorter';
import Filters from '../../../screens/Places/Filters';
// import SearchContainer from '../../../redux/containers/SearchContainer';
import SearchCards from '../../Trek/SearchCards';
import ServiceModalSlider from './ServiceModalSlider';
import Loading from '../../../components/Loading';

export default class CardContainer extends Component {
  state = { loading: false };
  async componentDidMount() {
    const { limit, page, searchTerm, themesArray, getPlaceThemes } = this.props;
    if (themesArray.length === 0) {
      this.setState({ loading: true });
      getPlaceThemes({ limit, page, categories: 'all', searchTerm }).then(() =>
        this.setState({ loading: false })
      );
    }
  }

  componentWillUnmount() {
    const { categories, searchTerm, clearThemeConfigs, refreshThemeData } = this.props;
    clearThemeConfigs();
    if (categories !== 'all' || searchTerm) {
      refreshThemeData();
    }
  }

  onloadMore = () => {
    const { limit, page, categories, searchTerm, getPlaceThemes } = this.props;
    return getPlaceThemes({ limit, page: page + 1, categories, searchTerm });
  };

  render() {
    const {
      themesArray,
      cardsArray,
      isLastPage,
      slideIndex,
      dayDate,
      getPlaceThemes,
      openSlider,
      openAlert,
      getPlaceThemesByCategories,
      getCardsBySearchTerm,
      limit,
      page,
      theme,
      categories,
      searchTerm,
      placeName,
      // placeId
    } = this.props;
    return (
      <Fragment>
        <div className="row mb-3">
          <div className="col-md-6 col-12 d-flex align-items-center">
            <h4>
              {' '}
              RECOMMENDED {theme.toUpperCase()} IN {placeName.toUpperCase()}
            </h4>
            <p className="d-block d-md-none mb-3">&nbsp;</p>
          </div>
          <div className="col-md-4 col-3 search-box">
            {theme === 'sightings' && (
              <SearchCards
                theme={theme}
                getCardsBySearchTerm={getCardsBySearchTerm}
                configs={{ limit, page, categories, searchTerm }}
              />
            )}
          </div>
          <div className="col-md-2 col-9 d-flex flex-row-reverse align-items-center sort-filter">
            <span>
              <Sorter theme={theme} />
            </span>
            <span>
              {theme === 'sightings' && (
                <Filters
                  theme={theme}
                  getThemesByCategories={getPlaceThemesByCategories}
                  configs={{ limit, page, categories, searchTerm }}
                />
              )}
            </span>
          </div>
        </div>
        <section className="card-container">
          <div className="row">
            <div className="lodge-slide-wrap">
              {this.state.loading ? (
                <div className="col-12 message-box" style={{ textAlign: 'center' }}>
                  <p style={{ padding: '3% 0' }}>
                    <Loading size="full" />
                  </p>
                </div>
              ) : themesArray.length === 0 ? (
                <div className="col-12 message-box" style={{ textAlign: 'center' }}>
                  <p style={{ padding: '10% 0' }}> No {theme} to show.</p>
                </div>
              ) : (
                <ServiceModalSlider
                  themesArray={themesArray}
                  cardsArray={cardsArray}
                  isLastPage={isLastPage}
                  slideIndex={slideIndex}
                  theme={theme}
                  configs={{ limit, page, categories, searchTerm }}
                  getPlaceThemes={getPlaceThemes}
                  openSlider={openSlider}
                  toggleAlert={openAlert}
                  placeName={placeName}
                  dayDate={dayDate}
                />
              )}
            </div>
          </div>
          {!isLastPage && <LoadMoreButton loadMore={this.onloadMore} />}
        </section>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Trek/ServiceModal/CardContainer.js